<template>
  <div>
    <template v-if="data.length != 0">
      <label>{{ $t('projects.activities.title') }}</label>
      <table class="w-100 table-bordered table-sm mb-3">
        <tr>
          <th class="name-row">
            <label class="mb-0">{{ $t('projects.activities.tableHead.1') }}</label>
          </th>
          <th>
            <label class="mb-0">{{ $t('projects.activities.tableHead.2') }}</label>
          </th>
          <th>
            <label class="mb-0">{{ $t('projects.activities.tableHead.3') }}</label>
          </th>
          <th>
            <label class="mb-0">{{ $t('projects.activities.tableHead.4') }}</label>
          </th>
          <th>
            <label class="mb-0">{{ $t('projects.activities.tableHead.5') }}</label>
          </th>
          <th>
            <label class="mb-0">{{ $t('projects.activities.tableHead.6') }}</label>
          </th>
        </tr>
        <tr v-for="(item, index) in data" :key="'activity_item_'+idArticleActivity+'_'+index">
          <td>
            <b-input-group size="sm" :prepend="'A'+item.type+'.'+getTypeIndex(index)" >
              <b-form-input size="sm" v-model="item.name" placeholder="CS/DE"></b-form-input>
            </b-input-group>
          </td>
          <td>
            <b-form-input size="sm" type="number" class="text-right" v-model="item.persons"></b-form-input>
          </td>
          <td>
            <b-form-input size="sm" type="number" class="text-right" v-model="item.days"></b-form-input>
          </td>
          <td>
            <b-form-input size="sm" type="number" class="text-right" readonly :value="item.persons * item.days"></b-form-input>
          </td>
          <td>
            <b-form-input size="sm" type="number" class="text-right" readonly :value="item.rate"></b-form-input>
          </td>
          <td>
            <b-form-input size="sm" type="number" class="text-right" readonly :value="item.rate * (item.persons * item.days)"></b-form-input>
          </td>
          <td>
            <b-button @click="deleteItem(item.id)" type="button" size="sm" variant="danger">
              <b-icon class="clickable" icon="trash-fill" variant=""></b-icon>
            </b-button>
          </td>
        </tr>
        <tr>
          <td>
            <b>{{ $t('projects.activities.total') }} A1</b>
          </td>
          <td colspan="5" class="text-right">
            <b>{{formatMoney(totalSumA1)}}&nbsp;€</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>{{ $t('projects.activities.total') }} A2</b>
          </td>
          <td colspan="5" class="text-right">
            <b>{{formatMoney(totalSumA2)}}&nbsp;€</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>{{ $t('projects.activities.total') }}</b>
          </td>
          <td colspan="5" class="text-right">
            <b>{{formatMoney(totalSum)}}&nbsp;€</b>
          </td>
        </tr>
      </table>
    </template>

    <b-button @click="addItem(1)" type="button" size="sm" class="mb-1" variant="primary">
      <b-icon class="clickable" icon="plus-square-fill" variant=""></b-icon>&nbsp;
      {{ $t('projects.activities.addBtnActivity1') }}
    </b-button>
    <b-button @click="addItem(2)" type="button" size="sm" class="mb-3" variant="primary">
      <b-icon class="clickable" icon="plus-square-fill" variant=""></b-icon>&nbsp;
      {{ $t('projects.activities.addBtnActivity2') }}
    </b-button>
  </div>

</template>

<script>
export default {
  name: "project-activity-items",
  props: {
    idArticleActivity: {
      type: Number
    },
  },
  data() {
    return {
      data: [],
    }
  },
  methods: {
    formatMoney(value) {
      if (typeof value !== 'number') {
        value = parseFloat(value);
        if (isNaN(value)) return '';
      }

      return value
          .toFixed(0) // dvě desetinná místa
          .replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // mezera mezi tisíci
    },
    async loadData() {
      try {
        const response = await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/articles/activity-items/list.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          params: {
            'id_articles_activities': this.idArticleActivity,
          },
          method: 'GET'
        });

        if (response.status == 200) {
          this.data = response.data;
        } else {
          this.data = [];
        }


      } catch (error) {
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },
    async updateItems() {
      try {
        await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/articles/activity-items/update-items.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: {
            'data': this.data,
            'id_articles_activities': this.idArticleActivity
          },
          method: 'PUT'
        });
      } catch (error) {
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },
    async addItem(type) {
      if (this.data.length != 0) {
        await this.updateItems();
      }
      try {
        await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/articles/activity-items/add-item.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: {
            'id_articles_activities': this.idArticleActivity,
            'type': type
          },
          method: 'POST'
        });

        await this.loadData();

      } catch (error) {
        await this.loadData();
        console.log("error", error);
      }

    },
    async deleteItem(id) {
      await this.updateItems();
      try {
        if (confirm(this.$t('projects.deleteItem'))) {
          await this.$http({
            url: process.env.VUE_APP_SERVER + 'api/articles/activity-items/remove-item.php',
            headers: {'content-type': 'application/x-www-form-urlencoded'},
            data: {
              'id': id,
            },
            method: 'DELETE'
          });
          await this.loadData();
          this.$eventHub.$emit('openMessageController', 'success', this.$t('messages.deleted'));
        }

      } catch (error) {
        await this.loadData();
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },
    emitTotalSum() {
      this.$emit("update-total", {
        id: this.idArticleActivity,
        total: this.totalSum,
      });
    },
    getTypeIndex(index) {
      const currentItem = this.data[index];
      const currentType = currentItem.type;

      // Spočítáme, kolikátý záznam tohoto typu už jsme prošli až do aktuální pozice
      let count = 0;
      for (let i = 0; i <= index; i++) {
        if (this.data[i].type === currentType) {
          count++;
        }
      }
      return count;
    }
  },
  watch: {
    // sledujeme `data`, hluboce, kvůli změnám v objektech
    data: {
      deep: true,
      handler() {
        this.emitTotalSum();
      },
    },
  },
  computed: {
    totalSum() {
      if (!Array.isArray(this.data)) {
        return 0;
      }

      return this.data.reduce((sum, item) => {
        const rate = Number(item.rate) || 0;
        const personDays = Number(item.persons * item.days) || 0;
        return sum + rate * personDays;
      }, 0);
    },
    totalSumA1() {
      if (!Array.isArray(this.data)) {
        return 0;
      }

      return this.data.reduce((sum, item) => {
        if (item.type !== 1) return sum;

        const rate = Number(item.rate) || 0;
        const persons = Number(item.persons) || 0;
        const days = Number(item.days) || 0;
        const personDays = persons * days;

        return sum + rate * personDays;
      }, 0);
    },
    totalSumA2() {
      if (!Array.isArray(this.data)) {
        return 0;
      }

      return this.data.reduce((sum, item) => {
        if (item.type !== 2) return sum;

        const rate = Number(item.rate) || 0;
        const persons = Number(item.persons) || 0;
        const days = Number(item.days) || 0;
        const personDays = persons * days;

        return sum + rate * personDays;
      }, 0);
    },
  },
  mounted() {
    this.loadData();
  }
}
</script>



<style scoped lang="scss">
  /* Chrome, Safari, Edge, Opera */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  table td {
    vertical-align: middle;
  }
  table th {
    padding-bottom: 0;
  }
  .table-bordered{
    border-color: #ffffff;
    tr td {
      border-color: #ffffff;
    }
  }
  .name-row {
    @media (min-width: 1000px) {
      width: 387px;
    }
  }
</style>